import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Table, Button, Row, Col, Spinner } from 'react-bootstrap';
import { FaChevronLeft } from "react-icons/fa6";
import { formatShortDate } from '../../utils/auxiliarFunctions';
import ExportToExcel from '../../components/ExportToExcel/ExportToExcel';
import { getUsersByDate, toggleAusenteConAviso } from '../../utils';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

const VerFechas = () => {
  const { idActividad, fecha } = useParams();
  const [alumnos, setAlumnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formattedDate, setFormattedDate] = useState('');
  const [nombreActividad, setNombreActividad] = useState('');
  const [alumnosPresentes, setAlumnosPresentes] = useState(0);
  const [alumnosAusentes, setAlumnosAusentes] = useState(0);
  const [alumnosAusentesConAviso, setAlumnosAusentesConAviso] = useState(0);
  const [chartData, setChartData] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAlumnos = async () => {
      const usersData = await getUsersByDate(idActividad, fecha);

      setNombreActividad(usersData.activityName);
      setAlumnos(usersData.usersDetails);

      setLoading(false);
    };

    fetchAlumnos();
  }, [idActividad, fecha]);

  useEffect(() => {
    setFormattedDate(formatShortDate(fecha))
  }, [fecha]);

  const handleToggleAusenteConAviso = async (userId, activar) => {
    await toggleAusenteConAviso(userId, activar, fecha, idActividad);

    setAlumnos(prev =>
      prev.map(a =>
        a.email === userId
          ? { ...a, present: false, ausenteConAviso: activar }
          : a
      )
    );
  };

  useEffect(() => {
    let ausentes = 0;
    let presentes = 0;
    let ausentesConAviso = 0;

    if (alumnos.length > 0) {
      alumnos.map((item) => {
        if (item.presente) {
          presentes = presentes + 1;
        } else if (item.ausenteConAviso) {
          ausentesConAviso = ausentesConAviso + 1;
        } else {
          ausentes = ausentes + 1;
        }
      })
    }
    setAlumnosPresentes(presentes);
    setAlumnosAusentes(ausentes);
    setAlumnosAusentesConAviso(ausentesConAviso);
    const data = [
      { name: "Presente", value: presentes },
      { name: "Ausente", value: ausentes },
      { name: "Ausente con aviso", value: ausentesConAviso },
    ];
    setChartData(data);
  }, [alumnos]);

  const COLORS = ["#4CAF50", "#F44336", "#FF9800"];

  if (loading) {
    return <div className='d-flex justify-content-center'><Spinner /></div>;
  }


  return (
    <Container className="py-4">
      <Button className="primaryBtn d-flex align-items-center" onClick={() => navigate(-1)}>
        <FaChevronLeft /> Volver
      </Button>
      <h1 className="mt-4 titles">Alumnos registrados en la actividad <span style={{ fontStyle: 'italic' }}>"{nombreActividad}"</span> para la fecha {formattedDate && formattedDate}</h1>

      {alumnos.length > 0 ? (
        <>
          <Row className='d-flex justify-content-end my-4'>
            <Col md={4} className='d-flex justify-content-end'>
              <ExportToExcel data={alumnos} filename={`alumnosPresentes-${formattedDate}.xlsx`} date={formattedDate} activityName={nombreActividad} />
            </Col>
          </Row>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Nombre y apellido</th>
                <th>Email</th>
                <th>Asistencia</th>
              </tr>
            </thead>
            <tbody>
              {alumnos.map((alumno) => (
                <tr key={alumno.email}>
                  <td>{alumno.name} {alumno.lastName}</td>
                  <td>{alumno.email}</td>
                  <td>
                    {alumno.present ? (
                      'Presente'
                    ) : alumno.ausenteConAviso ? (
                      <>
                        Ausente con aviso{' '}
                        <Button
                          size="sm"
                          variant="secondary"
                          onClick={() => handleToggleAusenteConAviso(alumno.email, false)}
                        >
                          Marcar ausente sin aviso
                        </Button>
                      </>
                    ) : (
                      <>
                        Ausente{' '}
                        <Button
                          size="sm"
                          variant="warning"
                          onClick={() => handleToggleAusenteConAviso(alumno.email, true)}
                        >
                          Marcar ausente con aviso
                        </Button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <p>No hay alumnos registrados en esta fecha.</p>
      )}
      <h1 className="mt-4 titles">Estadísticas de asistencia del día</h1>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            outerRadius={100}
            dataKey="value"
            label
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default VerFechas;
